// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e485cfbd","453":"ccdbd5ed","732":"295014f8"}[chunkId] + ".chunk.js";
};